
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg"
  },
  "children": [
    {
      "tag": "g",
      "attrsMap": {
        "id": "Order_confirmation"
      },
      "children": [
        {
          "tag": "path",
          "attrsMap": {
            "d": "M228.2588,453.47l2.04-18.38H90.209a10.0033,10.0033,0,0,1-10-10V88.15a10.0033,10.0033,0,0,1,10-10h211.14a10.0036,10.0036,0,0,1,10,10V246.62a55.7953,55.7953,0,0,1,15.24-9.14V60.61a32.7,32.7,0,0,0-32.7-32.7H97.6689a32.7,32.7,0,0,0-32.7,32.7V453.17a32.7,32.7,0,0,0,32.7,32.7h139.5A45.4382,45.4382,0,0,1,228.2588,453.47Zm-9.6,12.18h-45.76v-12h45.76Z"
          }
        },
        {
          "tag": "path",
          "attrsMap": {
            "d": "M156.8589,166.84a23.8988,23.8988,0,1,1-23.82-25.82v-11a34.895,34.895,0,1,0,34.84,36.82Z"
          }
        },
        {
          "tag": "path",
          "attrsMap": {
            "d": "M123.3818,153.4585l-8.8574,8.0957,13.1875,14.4277a6.0015,6.0015,0,0,0,4.39,1.9522h.039a6.0023,6.0023,0,0,0,4.376-1.8945L164.5117,146.2l-8.7519-8.2109-23.5616,25.1142Z"
          }
        },
        {
          "tag": "path",
          "attrsMap": {
            "d": "M156.8589,261.9226a23.8988,23.8988,0,1,1-23.82-25.82v-11a34.8951,34.8951,0,1,0,34.84,36.82Z"
          }
        },
        {
          "tag": "path",
          "attrsMap": {
            "d": "M123.3818,248.541l-8.8574,8.0957,13.1875,14.4278a6.0018,6.0018,0,0,0,4.39,1.9521h.039a6.0019,6.0019,0,0,0,4.376-1.8945l27.9951-29.8393-8.7519-8.211L132.1982,258.186Z"
          }
        },
        {
          "tag": "path",
          "attrsMap": {
            "d": "M98.1387,355.0894a34.8967,34.8967,0,0,0,69.74,1.92h-11.02a23.8988,23.8988,0,1,1-23.82-25.82v-11A34.9381,34.9381,0,0,0,98.1387,355.0894Z"
          }
        },
        {
          "tag": "path",
          "attrsMap": {
            "d": "M123.3818,343.6279l-8.8574,8.0957,13.1875,14.4278a6.0014,6.0014,0,0,0,4.39,1.9521h.039a6.0019,6.0019,0,0,0,4.376-1.8945L164.5117,336.37l-8.7519-8.2109-23.5616,25.1142Z"
          }
        },
        {
          "tag": "rect",
          "attrsMap": {
            "height": "12",
            "width": "72.6846",
            "x": "192.8047",
            "y": "146.8691"
          }
        },
        {
          "tag": "rect",
          "attrsMap": {
            "height": "12",
            "width": "50.5986",
            "x": "192.8047",
            "y": "170.9619"
          }
        },
        {
          "tag": "rect",
          "attrsMap": {
            "height": "12",
            "width": "50.5986",
            "x": "192.8047",
            "y": "239.9688"
          }
        },
        {
          "tag": "rect",
          "attrsMap": {
            "height": "12",
            "width": "72.333",
            "x": "192.8047",
            "y": "264.0615"
          }
        },
        {
          "tag": "path",
          "attrsMap": {
            "d": "M453.917,454.3008,439.8076,327.4414A20.4882,20.4882,0,0,0,419.4238,309.2H391.39V289.85a44.365,44.365,0,0,0-43.5429-44.3063c-24.7925-.4248-45.084,20.2965-45.084,45.0926V309.2H274.7285a20.4883,20.4883,0,0,0-20.3838,18.2422l-14.164,127.35a33.3819,33.3819,0,0,0,33.1777,37.0737h146.94a33.8255,33.8255,0,0,0,33.6182-37.5649ZM314.7627,289.85a32.3513,32.3513,0,0,1,31.7559-32.3081c18.0766-.3076,32.871,14.8732,32.871,32.9524V309.2H314.7627ZM436.5635,472.5947a21.8536,21.8536,0,0,1-16.2647,7.271h-146.94a21.3834,21.3834,0,0,1-21.252-23.747l14.1641-127.35a8.5018,8.5018,0,0,1,8.458-7.5689h28.0342V345h12V321.2H379.39V345h12V321.2h28.0342a8.5017,8.5017,0,0,1,8.458,7.5684l14.1094,126.8593A21.8513,21.8513,0,0,1,436.5635,472.5947Z"
          }
        }
      ]
    }
  ]
})
    }
  